import React from 'react';

import styles from './TableExpandedGroup.module.scss';

export interface TableExpandedGroupProps {
  /** Child of `Table.RowExpanded` which can be any element. */
  children: React.ReactNode;
  /** Dictate how many columns to display for the expanded group. */
  columns: 1 | 2;
}
export const TableExpandedGroup: React.FC<TableExpandedGroupProps> = ({
  children,
  columns = 1,
}) => {
  return (
    <div
      className={styles.expandedGroup}
      style={{
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
      }}
    >
      {children}
    </div>
  );
};

TableExpandedGroup.displayName = 'Table.ExpandedGroup';
export default TableExpandedGroup;
export { styles };
